import withErrorHandler from "../../../component/design-system/withErrorHandler";

// eslint-disable-next-line no-unused-vars
function RatingUI({
  PRODUCT_ID,
}: any) {
  return null;
  // return (
  // <div className="stjr-product-rating" data-product-id={PRODUCT_ID} />
  // );
}

export default withErrorHandler(RatingUI);
